export default __webpack_public_path__ + "static/media/noDemo.e4e28ba2.svg";